package org.teddapp.project.db.repo

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import app.cash.sqldelight.coroutines.mapToOneOrNull
import com.tedd.db.Objective
import com.tedd.db.TeddDatabase
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.withContext
import org.teddapp.project.db.newId
import org.teddapp.project.db.nowMillis

class ObjectiveRepository(private val db: TeddDatabase) {

    fun observeAll(): Flow<List<Objective>> =
        db.objectiveQueries.selectAll().asFlow().mapToList(Dispatchers.Default)

    fun observeById(id: String): Flow<Objective?> =
        db.objectiveQueries.selectById(id).asFlow().mapToOneOrNull(Dispatchers.Default)

    fun observeByCategory(categoryId: String): Flow<List<Objective>> =
        db.objectiveQueries.selectByCategory(categoryId).asFlow().mapToList(Dispatchers.Default)

    fun observeByStatus(status: String): Flow<List<Objective>> =
        db.objectiveQueries.selectByStatus(status).asFlow().mapToList(Dispatchers.Default)

    suspend fun create(
        title: String,
        categoryId: String? = null,
        description: String? = null,
        motivation: String? = null,
        deadline: String? = null,
        year: Long? = null,
        status: String = "active",
        progress: Long = 0,
        id: String = newId("obj"),
    ): String = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.objectiveQueries.insert(
            id, categoryId, title, description, motivation, deadline, year, status, progress, now, now,
        )
        id
    }

    suspend fun update(
        id: String,
        categoryId: String?,
        title: String,
        description: String?,
        motivation: String?,
        deadline: String?,
        year: Long?,
        status: String,
        progress: Long,
    ) = withContext(Dispatchers.Default) {
        db.objectiveQueries.update(
            categoryId, title, description, motivation, deadline, year, status, progress, nowMillis(), id,
        )
    }

    suspend fun updateProgress(id: String, progress: Long) = withContext(Dispatchers.Default) {
        db.objectiveQueries.updateProgress(progress, nowMillis(), id)
    }

    suspend fun softDelete(id: String) = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.objectiveQueries.softDelete(now, now, id)
    }

    suspend fun restore(id: String) = withContext(Dispatchers.Default) {
        db.objectiveQueries.restore(nowMillis(), id)
    }
}